import { AnyAction, SerializedError, ThunkDispatch } from "@reduxjs/toolkit";
import Ajv from "ajv";
import { AxiosResponse } from "axios";

import { addAlert, Severity } from "@/store/alerts/slice";


export interface LvtResponse<D> {
    data: D;
    status: number;
    statusMessage: string;
}

export function lvtResponseSchema(dataSchema: any) {
    return {
        type: "object",
        additionalProperties: false,
        required: ["status", "statusMessage", "data"],
        properties: {
            status: { const: 200 },
            statusMessage: { type: "string" },
            data: dataSchema,
        },
    };
}

export type LvtResponse2<D, E = unknown> = {
    data: D;
    error: null;
} | {
    data: null;
    error: E;
};

export const lvtResponseSchema2 = (dataSchema: any) => {
    return {
        type: "object",
        additionalProperties: false,
        required: ["data", "error"],
        properties: {
            data: dataSchema,
            error: {},
        },
    };
};

export const validateRequest = async <D>(
    dispatch: ThunkDispatch<unknown, unknown, AnyAction>,
    request: Promise<AxiosResponse<LvtResponse<D>>>,
    validator: Ajv.ValidateFunction,
    message: string,
) => {
    try {
        const response = await request;

        if (validator(response.data)) {
            return response.data.data;
        } else {
            const error: SerializedError = {
                name: "validation",
                message: JSON.stringify(validator.errors),
            };

            throw error;
        }
    } catch (e) {
        dispatch(
            addAlert({
                severity: Severity.Error,
                message,
            }),
        );

        console.log("ERROR: ", e);

        throw e;
    }
};
